module.exports = __webpack_public_path__ + "images/149_640.jpg";